module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Acknowledgements"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("Acknowledgements")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" would like to thank anyone who has assisted me over the years with information and photographs for my publications. For this book I would like to thank John Cloake, Gavin Goh, Ted Nevill at Cody Images, Mariusz Zimny and Wawrzyniec Markowski.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("All the photographs apart from those listed below are from the Philip Jowett collection.")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_vm._v("John Cloake: p. 122 (top)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Cody Images: pp. 96 (top) and 114 (top)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Gavin Goh: p. 85 (top)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Wawrzyniec Markowski: pp. 48 (top), 80 and 97 (bottom)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Mariusz Zimny: p. 60 (top)")])])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-667cacc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Acknowledgements.vue
// module id = 75
// module chunks = 0